export default __webpack_public_path__ + "static/media/datePicker.723f8cf6.svg";